import { useQuery } from "react-query";
import {
  BANK_URL,
  PRODUCT_URL,
  PRODUCT_URL_TYPE,
  SOURCING_PRODUCTS,
} from "../api/urls";
import { useAxios } from "./useAxios";

export const useProduce = () => {
  const axios = useAxios();
  return useQuery("products", async () => {
    const response = await axios.get(PRODUCT_URL);
    // SAFE: Fallback to empty array if data is missing
    return response?.data?.returned_resultset || [];
  });
};

export const useProduceTypes = () => {
  const axios = useAxios();
  return useQuery("product-types", async () => {
    const response = await axios.get(PRODUCT_URL_TYPE);

    const data = response?.data;
    if (!data || typeof data !== "object") {
      return [];
    }

    return data.returned_resultset ?? [];
  });
};

export const useBanks = () => {
  const axios = useAxios();
  return useQuery("banks", async () => {
    const response = await axios.get(BANK_URL);
    return response?.data?.returned_resultset || [];
  });
};

export const useSourcedProducts = (filters, offset = "") => {
  const axios = useAxios();
  return useQuery(["sourced", filters, offset], async () => {
    if (!filters) {
      return { returned_resultset: [], available_resultset_size: 0 };
    }
    const response = await axios.get(
      `${SOURCING_PRODUCTS}?${filters}${offset}&limit=10`,
    );
    const { returned_resultset = [], available_resultset_size = 0 } =
      response?.data || {};
    return { returned_resultset, available_resultset_size };
  });
};
